<template>
  <div class="app-container">
    <CrudTable entity="OrderLineStatus" :columns="columns" :show-action-icons-in-list="false" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

const Labels = {
  Yes: 'common.yes',
  No: 'common.no'
};

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        {
          field: 'code',
          label: 'common.code'
        },
        {
          field: 'name',
          label: 'orderLineStatus.orderLineSubstatus'
        },
        {
          field: 'orderLineStatusOption',
          label: 'orderLineStatus.orderLineStatus',
          formatter: this.formatOrderLineStatus,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('orderLineStatus'),
            valueField: 'code',
            labelField: 'description'
          }
        },
        {
          field: 'substatusOrder',
          label: 'orderLineStatus.substatusOrder'
        },
        {
          field: 'scanParameter',
          label: 'orderLineStatus.scanParameter'
        },
        {
          field: 'cancellationAllowedYN',
          label: 'orderLineStatus.cancellationAllowed',
          width: '160px',
          formatter: this.formatActive,
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'changableYN',
          label: 'orderLineStatus.changable',
          width: '160px',
          formatter: this.formatActive,
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'settableYN',
          label: 'orderLineStatus.settable',
          width: '160px',
          formatter: this.formatActive,
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'canBeRemovedFromSeriesYN',
          label: 'orderLineStatus.removeFromSeries',
          width: '160px',
          formatter: this.formatActive,
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'feedBackYN',
          label: 'orderLineStatus.feedBack',
          width: '160px',
          formatter: this.formatActive,
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    formatActive(row, column, cellValue) {
      return cellValue ? this.$t(Labels.Yes) : this.$t(Labels.No);
    },
    formatOrderLineStatus(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('orderLineStatus').find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>

<style scoped></style>
